import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import { useDispatch, useSelector } from "react-redux";
import {
  getSTreport,
  getCTreport,
  getBMreport,
  getCMreport,
  getSCMreport,
  getSMreport,
  getSHCHreport,
  getSrcHreport,
} from "../../reduxStore/action/reportActions";
import { handleListResponse } from "utils/utils";
import CountBoxCard from "../Dashboard/CountBoxCard";
import {
  ClosingManager,
  ClosingTL,
  SourcingManager,
  SourcingTL,
  SCM,

  // AdminRoleId,
  // PostSale,
  // Receptionist,
} from "../../utils/constants";
import MultiCountBoxCard from "./MultiCountBoxCard";
import ExcelJS from "exceljs";

const ReportUser = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formVaild, setFormVaild] = useState({});

  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const [form, setForm] = useState({
    start_date: "",
    end_date: "",
  });
  const [appointmentData, setAppointmentData] = useState([]);

  const [reportData, setReportData] = useState([]);
  const [closingManagerList, setClosingManagerList] = useState([]);
  const [getchannelPartnerList, setchannelPartnerList] = useState([]);
  const [sourcingManagerList, setSourcingManagerList] = useState([]);

  const { response: res } = useSelector((state) => state.login);

  const ReportSelector = useSelector((state) => state.report);

  const ctlTeam = ClosingTL === res?.data?.role_id;

  const stlTeam = SourcingTL === res?.data?.role_id;

  const smTeam = SourcingManager === res?.data?.role_id;

  const scmTeam = SCM === res?.data?.role_id;

  const cmTeam = ClosingManager === res?.data?.role_id;

  const permissionSelector = useSelector((state) => state.permission);
  const { response: permissionResp, isAdmin = false } = permissionSelector;

  const appointmentListSelector = useSelector((state) => state.appointment);
  const { response: resApp } = appointmentListSelector;

  useEffect(() => {
    if (stlTeam) {
      dispatch(
        getSTreport({
          start_date: new Date().toISOString().split("T")[0],
          end_date: new Date().toISOString().split("T")[0],
        })
      );
    }
  }, [dispatch]);

  useEffect(() => {
    if (ctlTeam) {
      dispatch(
        getCTreport({
          start_date: new Date().toISOString().split("T")[0],
          end_date: new Date().toISOString().split("T")[0],
        })
      );
    }
  }, [dispatch]);

  useEffect(() => {
    if (smTeam) {
      dispatch(
        getSMreport({
          start_date: new Date().toISOString().split("T")[0],
          end_date: new Date().toISOString().split("T")[0],
        })
      );
    }
  }, [dispatch]);

  useEffect(() => {
    if (cmTeam) {
      dispatch(
        getCMreport({
          start_date: new Date().toISOString().split("T")[0],
          end_date: new Date().toISOString().split("T")[0],
        })
      );
    }
  }, [dispatch]);

  useEffect(() => {
    if (scmTeam) {
      dispatch(
        getSCMreport({
          start_date: new Date().toISOString().split("T")[0],
          end_date: new Date().toISOString().split("T")[0],
        })
      );
    }
  }, [dispatch]);

  useEffect(() => {
    const { roleReport = null } = ReportSelector;
    if (roleReport && roleReport?.status === 200) {
      if (roleReport.data?.length > 0) {
        setReportData(handleListResponse(roleReport?.data));

        setSourcingManagerList(roleReport?.data[0]?.sm_list);
        setClosingManagerList(roleReport?.data[0]?.sm_list);
      }
    } else {
      setReportData([]);
    }
  }, [ReportSelector]);

  const filterDetail = () => {
    if (!handleValid()) {
      if (stlTeam) {
        dispatch(
          getSTreport({ start_date: form.start_date, end_date: form.end_date })
        );
      }
      if (ctlTeam) {
        dispatch(
          getCTreport({ start_date: form.start_date, end_date: form.end_date })
        );
      }
      if (smTeam) {
        dispatch(
          getSMreport({ start_date: form.start_date, end_date: form.end_date })
        );
      }
      if (cmTeam) {
        dispatch(
          getCMreport({ start_date: form.start_date, end_date: form.end_date })
        );
      }
      if (scmTeam) {
        dispatch(
          getSCMreport({ start_date: form.start_date, end_date: form.end_date })
        );
      }
    }
  };

  const filterReset = () => {
    if (stlTeam) {
      dispatch(
        getSTreport({
          start_date: new Date().toISOString().split("T")[0],
          end_date: new Date().toISOString().split("T")[0],
        })
      );
    }
    if (ctlTeam) {
      dispatch(
        getCTreport({
          start_date: new Date().toISOString().split("T")[0],
          end_date: new Date().toISOString().split("T")[0],
        })
      );
    }
    if (smTeam) {
      dispatch(
        getSMreport({
          start_date: new Date().toISOString().split("T")[0],
          end_date: new Date().toISOString().split("T")[0],
        })
      );
    }
    if (cmTeam) {
      dispatch(
        getCMreport({
          start_date: new Date().toISOString().split("T")[0],
          end_date: new Date().toISOString().split("T")[0],
        })
      );
    }
    if (scmTeam) {
      dispatch(
        getSCMreport({
          start_date: new Date().toISOString().split("T")[0],
          end_date: new Date().toISOString().split("T")[0],
        })
      );
    }
  };

  const handleValid = () => {
    let err = { ...formVaild };
    let formError = false;
    if (!form.start_date) {
      formError = true;
      err["start_date"] = strings.startDateErr;
    }
    if (!form.end_date) {
      formError = true;
      err["end_date"] = strings.endDateErr;
    }
    setFormVaild(err);
    return formError;
  };

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
    if (e.target.name === "start_date") {
      setFormVaild({
        ...formVaild,
        start_date: "",
      });
    } else if (e.target.name === "end_date") {
      setFormVaild({
        ...formVaild,
        end_date: "",
      });
    }
  };

  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();

    const currentDate = new Date();
    const formattedCurrentDate = currentDate.toLocaleDateString("en-GB"); // Format as dd-mm-yyyy

    // Get the start and end dates, or fallback to the current date
    const startDate = form.start_date
      ? new Date(form.start_date).toLocaleDateString("en-GB")
      : formattedCurrentDate;
    const endDate = form.end_date
      ? new Date(form.end_date).toLocaleDateString("en-GB")
      : formattedCurrentDate;

    if (stlTeam) {
      const stlSheet = workbook.addWorksheet("Sourcing TL Report");

      // Add main heading with date range
      const headingRow = stlSheet.addRow([
        `Report (${startDate} - ${endDate})`,
      ]);

      // Apply styles to the heading
      headingRow.font = { bold: true, size: 16 }; // Make it bold, larger, and white text
      headingRow.alignment = { horizontal: "center", vertical: "middle" }; // Center align horizontally and vertically
      stlSheet.mergeCells(`A1:E1`); // Merge cells to span across columns A to E (adjust the range if necessary)
      headingRow.height = 35; // Increase row height for the title

      // Add a background color to the heading row

      // Add Summary Data (Role, Leads, Walkins, etc.)
      const summaryData = [
        ["Name:", res?.data?.user_name],
        ["Role:", "Sourcing TL"],
        ["Leads:", reportData[0]?.total_leades],
        ["Site Visit Created:", reportData[0]?.site_visit_created],
        ["Walkins:", reportData[0]?.walkin],
        ["Bookings:", reportData[0]?.total_booking],
        ["Appointment with CP:", reportData[0]?.appointmentwithCp],
      ];

      summaryData.forEach((item) => {
        const row = stlSheet.addRow(item);
        row.font = { bold: true }; // Bold the summary labels
        row.alignment = { horizontal: "left" }; // Left align the labels
      });

      // Add an empty row to separate summary from detailed data
      stlSheet.addRow([]);

      // Add a header for the Detailed Data Table with bold headers
      const headers = [
        "SM Name",
        "Leads",
        "Site Visit Created",
        "Walkins",
        "Bookings",
      ];
      const headerRow = stlSheet.addRow(headers);
      headerRow.font = { bold: true }; // Bold the header row
      headerRow.alignment = { horizontal: "center", vertical: "middle" }; // Center the header row

      // Apply border to the header row
      headerRow.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
          bottom: { style: "thin" },
        };
      });

      // Adjust the column widths to make the table more readable
      stlSheet.getColumn(1).width = 20; // SM Name column width
      stlSheet.getColumn(2).width = 15; // Leads column width
      stlSheet.getColumn(3).width = 20; // Site Visit Created column width
      stlSheet.getColumn(4).width = 15; // Walkins column width
      stlSheet.getColumn(5).width = 15; // Bookings column width

      // Add rows for each sourcing manager from the list
      if (sourcingManagerList && sourcingManagerList.length > 0) {
        sourcingManagerList.forEach((sm) => {
          const row = stlSheet.addRow([
            sm.user_name,
            sm.total_leades,
            sm.site_visit_created,
            sm.walkin,
            sm.total_booking,
          ]);

          // Apply borders to each data row
          row.eachCell((cell) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              right: { style: "thin" },
              bottom: { style: "thin" },
            };
          });

          // Align the data in the rows to the center
          row.alignment = { horizontal: "center", vertical: "middle" };
        });
      }
    }

    // Create a worksheet for Closing Manager
    if (ctlTeam) {
      // Create a worksheet for Closing Manager
      if (ctlTeam && closingManagerList && closingManagerList.length > 0) {
        const cmSheet = workbook.addWorksheet("Closing TL Report");

        // Add main heading with date range
        const headingRow = cmSheet.addRow([
          `Report (${startDate} - ${endDate})`,
        ]);

        // Apply styles to the heading
        headingRow.font = { bold: true, size: 16 }; // Make it bold, larger, and white text
        headingRow.alignment = { horizontal: "center", vertical: "middle" }; // Center align horizontally and vertically
        cmSheet.mergeCells(`A1:E1`); // Merge cells to span across columns A to E (adjust the range if necessary)
        headingRow.height = 35; // Increas

        // Add Role and Personal Summary Data Above the Table
        cmSheet.addRow(["Name:", res?.data?.user_name]);
        cmSheet.addRow(["Role:", "Closing Manager"]);
        cmSheet.addRow(["Leads:", reportData[0]?.total_leades]);
        // cmSheet.addRow(['Site Visit Created:', reportData[0]?.site_visit_created]);
        // cmSheet.addRow(['Walkins:', reportData[0]?.walkin]);
        // cmSheet.addRow(['Bookings:', reportData[0]?.total_booking]);
        cmSheet.addRow(["Site Visit Created:"]);
        cmSheet.addRow(["  CP:", reportData[0]?.site_visit_created_cp]);
        cmSheet.addRow(["  Direct:", reportData[0]?.site_visit_created_direct]);
        cmSheet.addRow(["  Total:", reportData[0]?.site_visit_created]);

        // Add Walkins with CP and Direct sub-content
        cmSheet.addRow(["Walkins:"]);
        cmSheet.addRow(["  CP:", reportData[0]?.walkin_cp]);
        cmSheet.addRow(["  Direct:", reportData[0]?.walkin_direct]);
        cmSheet.addRow(["  Total:", reportData[0]?.walkin]);

        // Add Bookings with CP and Direct sub-content
        cmSheet.addRow(["Bookings:"]);
        cmSheet.addRow(["  CP:", reportData[0]?.booking_cp]);
        cmSheet.addRow(["  Direct:", reportData[0]?.booking_direct]);
        cmSheet.addRow(["  Total:", reportData[0]?.total_booking]);

        // Add an empty row to separate the summary from the detailed data
        cmSheet.addRow([]);

        // Add a header for the Detailed Data Table with bold headers
        const cmHeaders = ["CM Name", "", "CP", "Direct", "Total"];
        const cmHeaderRow = cmSheet.addRow(cmHeaders);
        cmHeaderRow.font = { bold: true }; // Bold the header row
        cmHeaderRow.alignment = { horizontal: "center", vertical: "middle" }; // Center the header row

        // Apply border to the header row
        cmHeaderRow.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
            bottom: { style: "thin" },
          };
        });

        // Adjust the column widths to make the table more readable
        cmSheet.getColumn(1).width = 20; // CM Name column width
        cmSheet.getColumn(2).width = 30; // Empty column width (between name and CP)
        cmSheet.getColumn(3).width = 10; // CP column width
        cmSheet.getColumn(4).width = 10; // Direct column width
        cmSheet.getColumn(5).width = 15; // Total column width

        // Add rows for each closing manager from the list
        closingManagerList.forEach((cm) => {
          // Leads Row
          const leadsRow = cmSheet.addRow([
            cm.user_name,
            "Leads",
            strings.notavailable,
            strings.notavailable,
            cm.total_leades,
          ]);
          // Apply borders to each data row
          leadsRow.eachCell((cell) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              right: { style: "thin" },
              bottom: { style: "thin" },
            };
          });

          // Site Visit Created Row
          const siteVisitRow = cmSheet.addRow([
            "",
            "Site Visit Created",
            cm.site_visit_created_cp,
            cm.site_visit_created_direct,
            cm.site_visit_created,
          ]);
          // Apply borders to each data row
          siteVisitRow.eachCell((cell) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              right: { style: "thin" },
              bottom: { style: "thin" },
            };
          });

          // Walkins Row
          const walkinsRow = cmSheet.addRow([
            "",
            "Walkins",
            cm.walkin_cp,
            cm.walkin_direct,
            cm.walkin,
          ]);
          // Apply borders to each data row
          walkinsRow.eachCell((cell) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              right: { style: "thin" },
              bottom: { style: "thin" },
            };
          });

          // Bookings Row
          const bookingsRow = cmSheet.addRow([
            "",
            "Bookings",
            cm.booking_cp,
            cm.booking_direct,
            cm.total_booking,
          ]);
          // Apply borders to each data row
          bookingsRow.eachCell((cell) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              right: { style: "thin" },
              bottom: { style: "thin" },
            };
          });
        });
      }
    }

    if (scmTeam || cmTeam) {
      // Create a worksheet for Closing Manager

      const scmSheet = scmTeam
        ? workbook.addWorksheet("SCM Report")
        : workbook.addWorksheet("CM Report");

      // Add main heading with date range
      const headingRow = scmSheet.addRow([
        `Report (${startDate} - ${endDate})`,
      ]);

      // Apply styles to the heading
      headingRow.font = { bold: true, size: 16 }; // Make it bold, larger, and white text
      headingRow.alignment = { horizontal: "center", vertical: "middle" }; // Center align horizontally and vertically
      scmSheet.mergeCells(`A1:E1`); // Merge cells to span across columns A to E (adjust the range if necessary)
      headingRow.height = 35; // Increas

      // Add Role and Personal Summary Data Above the Table
      scmSheet.addRow(["Name:", res?.data?.user_name]);
      scmSheet.addRow(["Role:", scmTeam ? "SCM" : "Closing Manager"]);
      scmSheet.addRow(["Leads:", reportData[0]?.total_leades]);
      if (scmTeam) {
        scmSheet.addRow([
          "Appointment With Cp:",
          reportData[0]?.appointmentwithCp,
        ]);
      }
      scmSheet.getCell("A2").font = { bold: true }; // Name label
      scmSheet.getCell("A3").font = { bold: true }; // Role label
      scmSheet.getCell("A4").font = { bold: true }; // Leads label
      scmSheet.getCell("A5").font = { bold: true }; // Leads label
      // cmSheet.addRow(['Site Visit Created:', reportData[0]?.site_visit_created]);
      // cmSheet.addRow(['Walkins:', reportData[0]?.walkin]);
      // cmSheet.addRow(['Bookings:', reportData[0]?.total_booking]);
      const siteVisitRow = scmSheet.addRow(["Site Visit Created:"]);
      siteVisitRow.font = { bold: true }; // Make the header bold
      scmSheet.addRow(["  CP:", reportData[0]?.site_visit_created_cp]);
      scmSheet.addRow(["  Direct:", reportData[0]?.site_visit_created_direct]);
      scmSheet.addRow(["  Total:", reportData[0]?.site_visit_created]);

      // Add Walkins with CP and Direct sub-content
      const WalkinRow = scmSheet.addRow(["Walkins:"]);
      WalkinRow.font = { bold: true }; // Make the header bold
      scmSheet.addRow(["  CP:", reportData[0]?.walkin_cp]);
      scmSheet.addRow(["  Direct:", reportData[0]?.walkin_direct]);
      scmSheet.addRow(["  Total:", reportData[0]?.walkin]);

      // Add Bookings with CP and Direct sub-content
      const bookingsRow = scmSheet.addRow(["Bookings:"]);
      bookingsRow.font = { bold: true }; // Make the header bold
      scmSheet.addRow(["  CP:", reportData[0]?.booking_cp]);
      scmSheet.addRow(["  Direct:", reportData[0]?.booking_direct]);
      scmSheet.addRow(["  Total:", reportData[0]?.total_booking]);

      // Add an empty row to separate the summary from the detailed data

      scmSheet.getColumn(1).width = 30; // First column width (e.g., 'Name:', 'Role:', etc.)
      scmSheet.getColumn(2).width = 25; // Second column width (e.g., values for Name, Role, etc.)
    }

    if (smTeam) {
      const stlSheet = workbook.addWorksheet("Sourcing Manager Report");

      // Add main heading with date range
      const headingRow = stlSheet.addRow([
        `Report (${startDate} - ${endDate})`,
      ]);

      // Apply styles to the heading
      headingRow.font = { bold: true, size: 16 }; // Make it bold, larger, and white text
      headingRow.alignment = { horizontal: "center", vertical: "middle" }; // Center align horizontally and vertically
      stlSheet.mergeCells(`A1:E1`); // Merge cells to span across columns A to E (adjust the range if necessary)
      headingRow.height = 35; // Increase row height for the title

      // Add a background color to the heading row

      // Add Summary Data (Role, Leads, Walkins, etc.)
      const summaryData = [
        ["Name:", res?.data?.user_name],
        ["Role:", "Sourcing Manager"],
        ["Leads:", reportData[0]?.total_leades],
        ["Site Visit Created:", reportData[0]?.site_visit_created],
        ["Walkins:", reportData[0]?.walkin],
        ["Bookings:", reportData[0]?.total_booking],
        ["Appointment with CP:", reportData[0]?.appointmentwithCp],
      ];

      summaryData.forEach((item) => {
        const row = stlSheet.addRow(item);
        row.font = { bold: true }; // Bold the summary labels
        row.alignment = { horizontal: "left" }; // Left align the labels
      });

      stlSheet.getColumn(1).width = 30; // First column width (e.g., 'Name:', 'Role:', etc.)
      stlSheet.getColumn(2).width = 25;
      // Add an empty row to separate summary from detailed data
    }

    // Create a worksheet for Walkins and Site Visits (combined view for all teams)

    // Generate and download the Excel file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "report.xlsx";
    link.click();
  };

  return (
    <div className="page-body">
      <div className="container-fluid">
        <div className="page-header">
          <div className="row">
            <div className="col-sm-12 col-xl-12">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-body">
                      <form className="theme-form">
                        <div className="row">
                          <div className="col-md-4">
                            <span className="cardText">
                              {strings.startDate}
                            </span>
                            <div
                              className="input-group date"
                              id="dt-date"
                              data-target-input="nearest"
                            >
                              <input
                                className="form-control datetimepicker-input digits"
                                type="date"
                                data-target="#dt-date"
                                name="start_date"
                                value={form.start_date}
                                onChange={handleInputField}
                                min={form.start_date}
                              />
                            </div>
                            {formVaild.start_date && (
                              <span style={{ color: "red" }}>
                                {formVaild.start_date}
                              </span>
                            )}
                          </div>
                          <div className="col-md-4">
                            <span className="cardText">{strings.endDate}</span>
                            <div
                              className="input-group date"
                              id="dt-date"
                              data-target-input="nearest"
                            >
                              <input
                                className="form-control datetimepicker-input digits"
                                type="date"
                                name="end_date"
                                value={form.end_date}
                                onChange={handleInputField}
                                min={form.start_date}
                                // max={form.end_date}
                              />
                            </div>
                            {formVaild.end_date && (
                              <span style={{ color: "red" }}>
                                {formVaild.end_date}
                              </span>
                            )}
                          </div>
                          <div className="col-md-4 pt-5">
                            <div className="form-group d-flex justify-content-end">
                              <button
                                className="btn btn-warning mr-4"
                                type="button"
                                onClick={filterDetail}
                              >
                                {strings.search}
                              </button>
                              <button
                                className="btn btn-dark"
                                type="button"
                                onClick={filterReset}
                              >
                                {strings.reset}
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row d-flex justify-content-between align-items-center">
            <div className="col-auto">
              <h3>{strings.reportUser}</h3>
            </div>

            {/* Button aligned to the right */}
            <div className="col-auto">
              <button onClick={exportToExcel} className="btn btn-primary">
                Export to Excel
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Container-fluid starts*/}
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="row">
              <div className="card-body">
                <div className="row">
                  {(stlTeam || ctlTeam || smTeam || scmTeam || cmTeam) && (
                    <div className={"col-sm-6"}>
                      <CountBoxCard
                        label={strings.leads}
                        count={reportData[0]?.total_leades}
                        // navigateLink="/visitor"
                      />
                    </div>
                  )}

                  {(stlTeam || smTeam) && (
                    <div className={"col-sm-6"}>
                      <CountBoxCard
                        label={strings.SiteVisitCreated}
                        count={reportData[0]?.site_visit_created}
                        // navigateLink="/visitor"
                      />
                    </div>
                  )}

                  {(ctlTeam || scmTeam || cmTeam) && (
                    <div className={"col-sm-6"}>
                      <MultiCountBoxCard
                        label={strings.SiteVisitCreated}
                        totalCount={reportData[0]?.site_visit_created} // Total count (direct + cp)
                        directCount={reportData[0]?.site_visit_created_direct} // Direct count
                        cpCount={reportData[0]?.site_visit_created_cp} // CP count
                        // navigateLink="/visitor"
                      />
                    </div>
                  )}
                </div>

                <div className="row">
                  {(stlTeam || smTeam) && (
                    <div className={"col-sm-6"}>
                      <CountBoxCard
                        label={strings.WalkIns}
                        count={reportData[0]?.walkin}
                        // navigateLink="/visitor"
                      />
                    </div>
                  )}

                  {(stlTeam || smTeam) && (
                    <div className={"col-sm-6"}>
                      <CountBoxCard
                        label={strings.bookings}
                        count={reportData[0]?.total_booking}
                        // navigateLink="/booking"
                      />
                    </div>
                  )}

                  {(ctlTeam || scmTeam || cmTeam) && (
                    <div className={"col-sm-6"}>
                      <MultiCountBoxCard
                        label={strings.WalkIns}
                        totalCount={reportData[0]?.walkin} // Total count (direct + cp)
                        directCount={reportData[0]?.walkin_direct} // Direct count
                        cpCount={reportData[0]?.walkin_cp} // CP count
                        // navigateLink="/visitor"
                      />
                    </div>
                  )}

                  {(ctlTeam || scmTeam || cmTeam) && (
                    <div className={"col-sm-6"}>
                      <MultiCountBoxCard
                        label={strings.bookings}
                        totalCount={reportData[0]?.total_booking} // Total count (direct + cp)
                        directCount={reportData[0]?.booking_direct} // Direct count
                        cpCount={reportData[0]?.booking_cp} // CP count
                        // navigateLink="/visitor"
                      />
                    </div>
                  )}
                </div>

                <div className="row d-flex justify-content-center align-items-center">
                  {(smTeam || scmTeam) && (
                    <div className={"col-sm-6"}>
                      <CountBoxCard
                        label={strings.apptWithCp}
                        count={reportData[0]?.appointmentwithCp}
                        // navigateLink="/visitor"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            {stlTeam && (
              <div className="col-xl-12">
                <div className="card height-equal">
                  <div className="card-header card-header-border">
                    <div className="row">
                      <div className="col-sm-6">
                        <h5>{strings.sourcingManager}</h5>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    {/* Check if appointmentData has data */}
                    {sourcingManagerList && sourcingManagerList.length > 0 ? (
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>SM Name</th>
                            <th>Leads</th>
                            <th>Site Visit created</th>
                            <th>Walkins</th>
                            <th>Bookings</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sourcingManagerList.map(
                            (
                              sm,
                              index // Show only top 5 items
                            ) => (
                              <tr key={index}>
                                <td>{sm.user_name}</td> {/* Customer name */}
                                <td>{sm.total_leades}</td> {/* Visitor count */}
                                <td>{sm.site_visit_created}</td>
                                <td>{sm.walkin}</td>
                                <td>{sm.total_booking}</td>
                                {/* Site visit count */}
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    ) : (
                      <h5 className="text-center">{strings.notavailable}</h5>
                    )}
                  </div>
                </div>
              </div>
            )}

            {ctlTeam && (
              <div className="col-xl-12">
                <div className="card height-equal">
                  <div className="card-header card-header-border">
                    <div className="row">
                      <div className="col-sm-6">
                        <h5>{strings.closingManager}</h5>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    {/* Check if closingManagerList has data */}
                    {closingManagerList && closingManagerList.length > 0 ? (
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>CM Name</th>
                            <th></th>
                            <th>CP</th>
                            <th>Direct</th>
                            <th>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {closingManagerList.map((cm, index) => (
                            <>
                              <tr key={index}>
                                <td rowSpan="4">{cm.user_name}</td>
                                {/* Leads Row */}
                                <td>Leads</td>
                                <td>{strings.notavailable}</td>
                                <td>{strings.notavailable}</td>
                                <td>{cm.total_leades}</td>
                              </tr>
                              <tr>
                                {/* Site Visit Created Row */}
                                <td>Site Visit Created</td>
                                <td>{cm.site_visit_created_cp}</td>
                                <td>{cm.site_visit_created_direct}</td>
                                <td>{cm.site_visit_created}</td>
                              </tr>
                              <tr>
                                {/* Walkins Row */}
                                <td>Walkins</td>
                                <td>{cm.walkin_cp}</td>
                                <td>{cm.walkin_direct}</td>
                                <td>{cm.walkin}</td>
                              </tr>
                              <tr>
                                {/* Bookings Row */}
                                <td>Bookings</td>
                                <td>{cm.booking_cp}</td>
                                <td>{cm.booking_direct}</td>
                                <td>{cm.total_booking}</td>
                              </tr>
                            </>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <h5 className="text-center">{strings.notavailable}</h5>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* Container-fluid Ends*/}
      </div>
    </div>
  );
};

export default ReportUser;
